<template>
    <div class="">

        <div class="u-body">        
            <h1 class="h2 mb-2 text-capitalize"> 
                {{ refs }}

                <RoleName
                    :name="auth.role">
                </RoleName>
            </h1>


            <Breadcrumb 
                :refs="refs" 
                :current="pgCurrent">
            </Breadcrumb>


            <Loading
                :status="pgLoading">
            </Loading>


            <form v-if="!pgLoading" @submit.prevent="handelSubmit" enctype="multipart/form-data">

                <div class="tab-content">
                    <div class="row"> 

                        <div class="col-md-12 mb-5">

                            <CountryForm
                                :image_base64="row.image_base64"
                                :image_preview="row.image_preview"

                                :agent_base64="row.agent_base64"
                                :agent_preview="row.agent_preview"

                                :title="row.title"
                                :sort="row.sort"
                                :status="row.status"
                                :viewInFooter="row.viewInFooter"

                                :body="row.body"
                                :hint="row.hint"
                                :address="row.address"
                                :contact="row.contact"
                                :name="row.name"
                                :position="row.position"
                                :email="row.email"
                                :google_maps="row.google_maps"

                                v-on:contentChange="handleContentChange">
                            </CountryForm>

                        </div>

                    </div>
                </div>

                
                <ButtonsCard
                    :btnLoading="btnLoading"
                    :btnCurrent="btnCurrent"
                    :refs="refs"
                        
                    v-on:submitClicked="handelSubmit"
                    v-on:cancelClicked="handleCancel">
                </ButtonsCard>
                
            </form>
        </div>

    </div>
</template>

<script>
import iziToast from 'izitoast'
    
export default {
    name: 'editOrNew',
    components: {
        RoleName: () => import('@/components/RoleName.vue'),
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        Loading: () => import('@/components/Loading.vue'),
        CountryForm: () => import('@/components/CountryForm.vue'),
        ButtonsCard: () => import('@/components/ButtonsCard.vue'),
    },
    data() {
        return {
            // auth
            auth: {
                role: '',
                access_token: '',
            },
            
            // row
            row: {

                image_base64: '',
                image_preview: '',

                agent_base64: '',
                agent_preview: '',

                // row
                title: '',
                body: '',
                hint: '',
                address: '',
                contact: '',
                name: '',
                position: '',
                email: '',
                google_maps: '',

                // sort
                sort: 0,

                // status
                status: 1,
                viewInFooter: 1,
            },
                
            pgCurrent: (this.$route.params.id) ? 'Edit' : 'Add New',
            msgCurrent: (this.$route.params.id) ? 'Updated' : 'Created',
            btnCurrent: (this.$route.params.id) ? 'Update' : 'Create',
            methodType: (this.$route.params.id) ? 'PUT' : 'POST',
            pgLoading: (this.$route.params.id) ? true : false,
            
                
            btnLoading: false,
            refs: 'countries'
        }
    },
    mounted() {},
    computed: {},
    created() {

        // AccessToken & Role
        if(localStorage.getItem('role')) {
            this.auth.role = localStorage.getItem('role');
        }
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }

        if(this.$route.params.id) {
            this.fetchRow();
        }
    },
    methods: {
            
            
        // fetch Row
        fetchRow() {
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                method: 'GET',
                data: {}
            }
            this.axios(options)
            .then(res => {
                this.pgLoading = false;

                this.row.image_base64 = (res.data.row.image) ? res.data.row.image.url : '';
                this.row.image_preview = (res.data.row.image) ? res.data.row.image.url : '';

                this.row.agent_base64 = (res.data.row.agent) ? res.data.row.agent.url : '';
                this.row.agent_preview = (res.data.row.agent) ? res.data.row.agent.url : '';

                // row
                this.row.title = res.data.row.title;
                this.row.body = res.data.row.body;
                this.row.hint = res.data.row.hint;
                this.row.address = res.data.row.address;
                this.row.contact = res.data.row.contact;
                this.row.name = res.data.row.name;
                this.row.position = res.data.row.position;
                this.row.email = res.data.row.email;
                this.row.google_maps = res.data.row.google_maps;

                // sort
                this.row.sort = res.data.row.sort;

                // status
                this.row.status = res.data.row.status;
                this.row.viewInFooter = res.data.row.viewInFooter;
            })
            .catch(err => {

                // 403 Forbidden
                if(err.response && err.response.status == 401) {
                    this.clearLocalStorage();
                    this.$router.push({ name: 'login' });
                } else if(err.response && err.response.status == 403) {
                    this.$router.push({ name: 'forbidden' });
                } else {
                    this.btnLoading = false;
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: err.response.data.message
                    });
                }

            })
            .finally(() => {});
        },
            

        // handle edit Or New submit
        handelSubmit(){
            this.btnLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
            const options = {
                url: (this.$route.params.id) ? window.baseURL+'/'+this.refs+'/'+this.$route.params.id : window.baseURL+'/'+this.refs,
                method: this.methodType,
                data: {
                    'image_base64': this.row.image_base64,
                    'agent_base64': this.row.agent_base64,

                    // title
                    title: this.row.title,
                    body: this.row.body,
                    hint: this.row.hint,
                    address: this.row.address,
                    contact: this.row.contact,
                    name: this.row.name,
                    position: this.row.position,
                    email: this.row.email,
                    google_maps: this.row.google_maps,

                    // sort
                    sort: this.row.sort,

                    // status
                    status: this.row.status,
                    viewInFooter: this.row.viewInFooter,
                }
            }
            this.axios(options, config)
            .then(() => {
                this.btnLoading = false;
                iziToast.success({
                    icon: 'ti-check',
                    title: 'Great job,',
                    message: 'Item '+this.msgCurrent+' Successfully.',
                });
                    
                this.$router.push({ name: this.refs });
            })
            .catch(err => {
                        
                // 403 Forbidden
                if(err.response && err.response.status == 401) {
                    this.clearLocalStorage();
                    this.$router.push({ name: 'login' });
                } else if(err.response && err.response.status == 403) {
                    this.$router.push({ name: 'forbidden' });
                } else {
                    this.btnLoading = false;
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: err.response.data.message
                    });
                }
            })
            .finally(() => {})

        },

          
        // clear Local Storage
        clearLocalStorage() {
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_image');
            localStorage.removeItem('user_name');
            localStorage.removeItem('user_id');
            localStorage.removeItem('role');
        },


        // Cancel
        handleCancel(){
            if(confirm('Are You Sure?')) {
                this.$router.push({ name: this.refs });
            }
        },



        // handel Changes from child components
        handleContentChange(event) {
            this.row.image_base64 = event.image_base64;
            this.row.agent_base64 = event.agent_base64;
            this.row.title = event.title;
            this.row.body = event.body;
            this.row.hint = event.hint;
            this.row.address = event.address;
            this.row.contact = event.contact;
            this.row.name = event.name;
            this.row.position = event.position;
            this.row.email = event.email;
            this.row.google_maps = event.google_maps;
            this.row.sort = event.sort;    
            this.row.status = event.status;
            this.row.viewInFooter = event.viewInFooter;
        },
        
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
